import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

// Replace with your **publishable key** from Stripe dashboard
const PUBLIC_KEY = "pk_test_51R4JIfPs9SlHAQ3iVqUqlXkxoyR3IS7Od5od3ngpwtHiWOhaIkDPR1sZ3UW7hmEgyyRceaMPIm5PLCMBmanvIqGt00Iqhg3ypS";

const stripePromise = loadStripe(PUBLIC_KEY);

export default function StripeContainer({ children }) {
  return <Elements stripe={stripePromise}>{children}</Elements>;
}
